class PolyfillService {
    initializePolyfill(domain: any) {
        const script = document.createElement("script");
        script.src = `${domain}/polyfills.js`;
        script.async = true;
        document.body.appendChild(script);
        
        //AV-120 hotfix to make sure polyfills are ready before main.js is loaded
        setTimeout(() => {
            const script = document.createElement("script");
            script.src = `${domain}/main.js`;
            script.async = true;
            document.body.appendChild(script);
        }, 50);

        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${domain}/styles.css`;
        document.head.appendChild(link);
    }
}

const polyfill = new PolyfillService();

export default polyfill;